import { useRef, useState } from "react";
import {
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Stack,
} from "@mui/material";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import GroupIcon from "@mui/icons-material/Group";

import "assets/styles/piny.css";
import { useHistory } from "react-router-dom";

export default function ExploreItem() {
  const history = useHistory();

  const [menuOpen, setMenuOpen] = useState(false);
  const menuAnchorRef = useRef(null);

  const handleExploreClick = () => {
    setMenuOpen(!menuOpen);
  };

  const handleMenuClose = () => {
    setMenuOpen(false);
  };

  return (
    <div
      id="explore-item-div"
      ref={menuAnchorRef}
      aria-controls={menuOpen ? "explore-menu" : undefined}
      aria-expanded={menuOpen ? "true" : undefined}
      aria-haspopup="true"
      onClick={handleExploreClick}
      style={{ cursor: "pointer" }}
    >
      <span className="headerMenuItem">Explore</span>
      <Popper
        open={menuOpen}
        anchorEl={menuAnchorRef.current}
        role={undefined}
        placement="bottom"
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: "top",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleMenuClose}>
                <MenuList id="explore-menu">
                  <MenuItem onClick={() => history.push(`/explore/marker`)}>
                    <Stack
                      flexDirection="row"
                      alignItems="center"
                      padding="8px 0px 8px 0px"
                    >
                      <FmdGoodOutlinedIcon
                        style={{ width: "26px", height: "26px" }}
                      />
                      <span style={{ marginLeft: "4px" }}>Markers</span>
                    </Stack>
                  </MenuItem>
                  <MenuItem onClick={() => history.push(`/explore/event`)}>
                    <Stack
                      flexDirection="row"
                      alignItems="center"
                      padding="8px 0px 8px 0px"
                    >
                      <GroupIcon style={{ width: "26px", height: "26px" }} />
                      <span style={{ marginLeft: "4px" }}>Events</span>
                    </Stack>
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
}
